export default "__VITE_ASSET__D_9e5ACq__"